module.exports = __webpack_public_path__ + "img/@muri_org.84ba6121.png";